import _ from 'lodash';
import React from "react";
import style from "./homepage.scss"
import Photo from "@/components/Photo";

export const photoOf = (photo) => {
  return (
    <>
      <Photo photo={photo} />
    </>
  )
}

export const titleOf = (photo) => {
  return (
    <>
      <div className={style.photoTitle}>{photo.title}</div>
    </>
  )
}
export const commentOf = (photo) => {
  return (
    <>
      <div className={style.photoComment}>{photo.comment}</div>
    </>
  )
}

export const typeOf = (photo) => {
  return _.find(displayTypes, {type: photo.displayType})
}

export const contents = (photo) => {
  const type = typeOf(photo)
  return (
    <>
      <div className={style.photoPanel}>
        {_.map(type.order, (fn, i) => {
          return (<React.Fragment key={i}>{fn(photo)}</React.Fragment>)
        })}
      </div>
    </>
  )
}

export const displayTypes = [
  {type: 0, display: '写真,見出し,本文', order: [photoOf, titleOf, commentOf]},
  {type: 1, display: '見出し,写真,本文', order: [titleOf, photoOf, commentOf]},
  {type: 2, display: '見出し,本文,写真', order: [titleOf, commentOf, photoOf]}
]
